import { Provider } from '../Types';
import requestClient from '../components/Utility/RequestClient';

export const providerService = {
    getProviders: async (): Promise<{ data: Provider[] }> => {
        return requestClient.get(`/providers/get`);
    },
};
